import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-update-task-data-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class TaskUpdateTaskDataApiManualV2Component extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.updateTask"),
            description: this.translation.t("specs.updateTaskDescription"),
            httpMethod: "POST",
            path: "/taskdata/v2/tasks/{guid}",

            parameters: [
                {
                    name: "guid",
                    description: this.translation.t("parameters.updateTaskGuidDescription"),
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "name",
                    description: this.translation.t("parameters.updateTaskNameDescription"),
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "new task name",
                },
                {
                    name: "description",
                    description: this.translation.t("parameters.updateTaskDescriptionDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "new task description",
                },
                {
                    name: "responsibles",
                    description: this.translation.t("parameters.updateTaskResponsiblesDescription"),
                    in: "body",
                    paramType: "array",
                    required: true,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000000"
                    ]
                },
                {
                    name: "reviewers",
                    description: this.translation.t("parameters.updateTaskReviewersDescription"),
                    in: "body",
                    paramType: "array",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000000"
                    ]
                },
                {
                    name: "actionDate",
                    description: this.translation.t("parameters.updateTaskActionDateDescription"),
                    in: "body",
                    paramType: "date",
                    required: true,
                    example: "2021-07-21",
                },
                {
                    name: "comments",
                    description: this.translation.t("parameters.updateTaskCommentsDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "new comments on the task",
                },
                {
                    name: "score",
                    description: this.translation.t("parameters.taskScoreDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "1",
                },
                {
                    name: "notifications",
                    description: this.translation.t("parameters.updateTaskNotificationsDescription"),
                    in: "body",
                    paramType: "array of integers",
                    required: false,
                    example: [4, 5, 11],
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                },
            ],
        };
    }
}
